export default "__VITE_ASSET__D4r6f6Ir__"